// Configuration for Logs | Quo
export const CONFIG = {
  // API Configuration
  API_BASE_URL: '/api',
  
  // Default Settings
  DEFAULT_UPDATE_INTERVAL: 1000,
  DEFAULT_THEME: 'terminal',
  DEFAULT_TIMEZONE: 'Asia/Kolkata',
  DEFAULT_TIME_FORMAT: '12hr',
  DEFAULT_FONT_SIZE: 14,
  
  // Feature Flags
  ENABLE_SCAN_LINES: false,
  ENABLE_GLOW_EFFECT: false,
  ENABLE_VIRTUAL_SCROLLING: true,
  
  // Performance
  VIRTUAL_SCROLL_BUFFER: 50,
  MAX_LOGS_PER_SESSION: 10000,
  
  // Retry Configuration
  MAX_RETRIES: 1,
  RETRY_DELAY: 1000,
  
  // UI Configuration
  TOAST_DURATION: 3000,
  SCROLL_INCREMENT: 100,
}

export default CONFIG
